"use client";

import { Button } from "@/components/ui/button";
import { useFieldArray, useFormContext, useWatch } from "react-hook-form";

import type { StepId } from "@/features/multistep/registry/types";
import { useLocations } from "@/hooks/use-location";
import { Plus } from "lucide-react";
import { MiembroForm } from "./junta-directiva/miembro-form";

export function JuntaDirectivaStep({ stepId }: { stepId: StepId }) {
  const { control, trigger } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: `${stepId}.miembros`,
  });

  const { paises } = useLocations();

  // 👇 Observa todos los miembros de una sola vez
  const miembros =
    useWatch({
      control,
      name: `${stepId}.miembros`,
    }) || [];

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold">Miembro de junta</h2>


      {fields.map((field, index) => {
        const miembro = miembros[index] || {};

        return (
          <MiembroForm
            key={field.id}
            index={index}
            stepId={stepId}
            miembro={miembro}
            remove={remove}
            paises={paises}
          />
        );
      })}

      {/* Botón agregar */}
      <Button
        type="button"
        variant="outline"
        onClick={() => {
          append({
            tipoDocumento: "",
            numeroDocumento: "",
            nombreCompleto: "",
            telefono: "",
            pais: "",
            departamento: "",
            ciudad: "",
          });

          trigger(`${stepId}.${fields.length}`);
        }}
      >
        <Plus className="h-4 w-4 mr-2" />
        Agregar miembro
      </Button>
    </div>
  );
}
